import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { DoubleRightOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import gridSelector from 'common/components/grid-view/controllers/selectors';
import selectorUser from '@redux/user/selectors';

import { checkIsSuperAdmin } from 'utils';
import { useGlobalModal } from 'hooks';

const MoveGLNToMember = () => {
  const userInfo = useSelector(selectorUser.makeSelectUserInfo());
  const { MODAL_NAMES, openModal } = useGlobalModal();

  const isSuperAdmin = checkIsSuperAdmin(userInfo?.roles);
  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const openModalMoveAssetToMember = () => {
    openModal(MODAL_NAMES.REASSIGN_GLN_TO_MEMBER);
  };

  const isAllowToMoveGln = useMemo(() => {
    const isAllow =
      (userInfo?.isSuperMember || isSuperAdmin) &&
      selectedItemDetailList?.[0]?.glns?.length !== 0 &&
      selectedItemDetailList?.length === 1;

    return isAllow;
  }, [selectedItemDetailList, userInfo, isSuperAdmin]);

  return (
    <RibbonButton
      size='small'
      icon={<DoubleRightOutlined />}
      label='Reassign GLNs to Member'
      onClick={openModalMoveAssetToMember}
      disabled={!isAllowToMoveGln}
    />
  );
};

export default MoveGLNToMember;
